import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { useAtom } from "jotai";
import CodeReferencePreview from "organisms/code-reference-block-editor/code-reference-preview";
import {
    SECTION_DRAG_AND_DROP_SCOPE_NAME,
    SECTION_DROPPABLE_ID,
} from "organisms/drag-and-drop/use-drag-and-drop-section";
import { DroppedSection } from "utilities/atoms/section-drag-and-drop/dropped-section";
import { useSharedDragAndDropContext } from "utilities/contexts/shared-drag-and-drop/shared-drag-and-drop-context";
import { ScopedDragAndDropData } from "utilities/contexts/shared-drag-and-drop/scoped-drag-and-drop-data";

interface SectionDroppableConfiguration {
    data: ScopedDragAndDropData;
    id: string;
}

interface SectionDropZoneProps {
    placeholderText: string;
}

const CSS_CLASS_NAME = "c-section-drop-zone";

const SectionDropZone = ({ placeholderText }: SectionDropZoneProps) => {
    const droppableConfiguration: SectionDroppableConfiguration = {
        data: { scope: SECTION_DRAG_AND_DROP_SCOPE_NAME },
        id: SECTION_DROPPABLE_ID,
    };
    const { isOver, setNodeRef } = useDroppable(droppableConfiguration);

    const { isDropped } = useSharedDragAndDropContext();
    const [droppedSection] = useAtom(DroppedSection);

    return (
        <div
            className={`${CSS_CLASS_NAME} ${isOver ? "-over" : ""}`}
            ref={setNodeRef}>
            {isDropped && droppedSection ? (
                <CodeReferencePreview referenceSection={droppedSection} />
            ) : (
                placeholderText
            )}
        </div>
    );
};

export default SectionDropZone;
